import { restoredParagraphAfterFourSpaces } from "./disable-indented-code-block";

/** @type {RichEditorExtension} */
const extension = {
  plugins({ pmState: { Plugin, TextSelection }, schema }) {
    return new Plugin({
      appendTransaction(transactions, oldState, newState) {
        if (!transactions.some((transaction) => transaction.docChanged)) {
          return null;
        }

        const $old = oldState.selection.$from;
        const $new = newState.selection.$from;

        if ($old.parent.type !== schema.nodes.paragraph) {
          return null;
        }

        if ($new.parent.type !== schema.nodes.code_block) {
          return null;
        }

        const restored = restoredParagraphAfterFourSpaces(
          $old.parent.textContent,
          $old.parentOffset
        );

        if (restored === null) {
          return null;
        }

        const from = $new.before($new.depth);
        const to = $new.after($new.depth);
        const paragraph = schema.nodes.paragraph.create(
          null,
          schema.text(restored)
        );
        const transaction = newState.tr.replaceWith(from, to, paragraph);
        const cursor = from + 1 + 4;

        transaction.setSelection(TextSelection.create(transaction.doc, cursor));
        return transaction;
      },
    });
  },
};

export default extension;
